import styled from 'styled-components';

export const MyProfile = styled.div`
`;

export const ProfileImageWrapper = styled.div`
    margin-bottom: 24px;
`;

export const LabelOwnerWrapper = styled.div`
    display: flex;
`;

export const SvgOwnerWrapper = styled.div`
    width: 20px;
    height: 20px;
    margin-right: 4px;
`;